module.exports = __webpack_public_path__ + "static/img/Login.2cccb50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/Login.png
// module id = f9j9
// module chunks = 0